module.exports = __webpack_public_path__ + "img/icon-for-select.171682ed.svg";